import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemAttachmentSelector =
  (bomItemId: string) => (state: RootAppState) => {
    if (bomItemId === state.project?.activeProject?.id) {
      return state.project.activeProject.attachments
    }

    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem.type === 'MaterialHeader' || bomItem.type === 'RoutingHeader') {
      throw Error('material header does not have attachments')
    }

    return bomItem.attachments
  }

export const bomItemAttachmentCounterSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return bomItemAttachmentSelector(bomItemId)(state)?.length
  }
